import { Link } from "react-router-dom";
import { FaTimes, FaTrash, FaEdit, FaCheck } from "react-icons/fa";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import { toast } from "sonner";
import { useGetUsersQuery,
         useDeleteUserMutation,
 } from '../../slices/usersApiSlice.js'



function UserListScreen() {

  const { data: users, refetch, error } = useGetUsersQuery()

  const [deleteUser, { isLoading: loadingDelete }] = useDeleteUserMutation()

  async function deleteHandler(id) {
    if (window.confirm('Are you sure?')) {
      try {
        await deleteUser(id)
        refetch()
        toast.success('User deleted succesfully')
      } catch (err) {
        toast.error(err?.data?.message || err.error)
      }
    }
  }

  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-semibold text-slate-900">Users</h1>
      {loadingDelete ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">
              <tr>
                <th className="px-4 py-3">ID</th>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Admin</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 text-slate-700">
              {users?.map((user) => (
                <tr key={user._id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 font-mono text-xs text-slate-600">{user._id}</td>
                  <td className="px-4 py-3">{user.name}</td>
                  <td className="px-4 py-3">
                    <a
                      href={`mailto:${user.email}`}
                      className="text-sky-700 underline-offset-2 hover:underline"
                    >
                      {user.email}
                    </a>
                  </td>
                  <td className="px-4 py-3">
                    {user.isAdmin ? (
                      <FaCheck className="text-green-600" />
                    ) : (
                      <FaTimes className="text-red-500" />
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <Link
                        to={`/admin/user/${user._id}/edit`}
                        className="inline-flex rounded-lg border border-slate-300 bg-white p-2 text-slate-700 hover:bg-slate-50"
                        aria-label="Edit user"
                      >
                        <FaEdit />
                      </Link>
                      <button
                        type="button"
                        onClick={() => deleteHandler(user._id)}
                        className="inline-flex rounded-lg bg-red-600 p-2 text-white hover:bg-red-700"
                        aria-label="Delete user"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default UserListScreen

